import React, { Component } from 'react';

class RoamingCard extends Component {

  constructor( props ) {
    super(props);
  }

  componentWillMount() {

  }

  getInnerHTML(details) {
    let html = details.map( ( detail, index ) =>
      <li key={index} className="col-xs-6">
        <div className="deal-wrapper">
          <span className="deal-property">{detail.headline}</span>
          <p className="deal-price">${detail.price}</p>
          {/* <span className="deal-day"> {detail.day}</span> */}
        </div>
      </li>
    );

    return (
      <ul className="quiz-card-deals row">
       {html}
      </ul>
    )
  }

  handleQuizCardClick(e) {
	window.location = e.currentTarget.getAttribute('data-href');
  }

  render() {

    var array = [];

    if( typeof this.props.plans != "undefined" && this.props.plans.length ) {

      for( let i = 0; i < this.props.plans.length; i++ ) {
        // if(this.props.plans.includes(this.props.plans[i])){
          array.push(this.props.roamingData.plans[this.props.plans[i]]);
        // }
      }

    } else {
      array = this.props.cards;
    }
    
    array = array.sort((a,b)=> a.sortId - b.sortId);

    switch( array.length ) {
      case 1:
        var classNameCol="col-xs-12";
      break;

      case 2:
        var classNameCol="col-sm-12 col-md-6 col-lg-4";
      break;

      default:
        if( this.props.type == "quizRoaming" ) {
          var classNameCol="col-sm-12 col-md-6 col-lg-4";
        } else {
          var classNameCol="col-sm-6 col-lg-4"
        }
    }

    let html = array.map( ( item, index) =>
      <li key={index} className={classNameCol}>
        <div className="quiz-card-inner" role="radio" tabIndex="0" data-href={item.url} onClick={this.handleQuizCardClick}>
          <div className="quiz-card-top">
            <span className="deal-title">{item.title}</span>
            <p className="deal-description">{item.desc}</p>
          </div>
          <div className="quiz-card-content">
            <div className="quiz-card-body">
              {this.getInnerHTML(item.details)}
            </div>
            <div className="quiz-card-footer">
              {item.footnote == "" ? "\u00A0" : item.footnote}
            </div>
          </div>
        </div>
      </li>
    );

    return (
      <ul className="quiz-cards row">
        {html}
      </ul>
    );


  }

}

export default RoamingCard;
